// noRedirectProtectedUrls => urls where the "voir" button won't be displayed
export const noRedirectProtectedUrls = ['/consultation', '/transmission']

// noDisplayProtectedUrls => urls where the notifications won't be displayed
export const noDisplayProtectedUrls = ['/cgu']

export const CONSULTATION_KEYS = [
    'pendingConsultations',
    'startedConsultations',
    'pendingConsultations-count',
    'startedConsultations-count',
]

export const TRANSMISSION_KEYS = ['transmissions', 'transmissions-count']
